import { Button } from 'components/Button'
import { Copy } from 'almanac-ui/icons'
import { useField } from 'formik'
import { useCopyToClipboard } from 'react-use'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

interface Props {
  name: string
}

export const CopyButton = ({ name }: Props) => {
  const [field] = useField(name)
  const [, copyToClipboard] = useCopyToClipboard()

  const handlePress = () => {
    copyToClipboard(field.value)
    showToastMessage('Prompt copied', 'success')
  }

  return (
    <Button frontIcon={Copy} size="md" variant="tertiaryGreen" onPress={handlePress} isDisabled={!prompt}>
      Copy
    </Button>
  )
}
